'use client'

import { memo, useCallback } from 'react'

import { useCartStore } from 'modules/cart'
import LoadingIndicator from 'shared/ui/LoadingIndicator/LoadingIndicator'
import { Modal, ModalDescription, ModalTitle } from 'shared/ui/Modal'

import { useSubmitEditSaleOrder } from '../../hooks/useSubmitEditSaleOrder'

import SubmitEditSaleOrderModalBlikModal from './SubmitEditSaleOrderModalBlikModal'
import { ModalSubmitEditContent } from './SubmitEditSaleOrderModalContent'

import styles from './SubmitEditSaleOrderModal.module.scss'

interface SubmitEditSaleOrderModalProps {
  open: boolean
  onClose: () => void
}

const SubmitEditSaleOrderModal = memo(({ open, onClose }: SubmitEditSaleOrderModalProps) => {
  const { cart, hasPendingOperations } = useCartStore()

  const {
    paymentLoading,
    blikCode,
    blikCodeModalOpen,
    editStatusObject,
    handleCreateOrder,
    handleBlikCodeChange,
    toggleBlikCodeModal
  } = useSubmitEditSaleOrder({
    open
  })

  const handleCloseModal = useCallback(() => {
    toggleBlikCodeModal(false)
    onClose()
  }, [onClose, toggleBlikCodeModal])

  if (!editStatusObject) return null

  return (
    <>
      <Modal id='submit-edit-modal' open={open} onClose={handleCloseModal}>
        <ModalTitle>Zapisz zmiany</ModalTitle>
        <ModalDescription visuallyHidden={true}>
          Potwierdź edycję zamówienia
        </ModalDescription>
        {hasPendingOperations() ? (
          <div className={styles.loaderWrapper}>
            <LoadingIndicator />
          </div>
        ) : (
          <ModalSubmitEditContent
            editStatusObject={editStatusObject}
            paymentLoading={paymentLoading}
            onBlikModalOpen={() => toggleBlikCodeModal(true)}
            onCreateOrder={handleCreateOrder}
            onClose={onClose}
            cart={cart}
          />
        )}
      </Modal>

      <SubmitEditSaleOrderModalBlikModal
        open={blikCodeModalOpen}
        paymentLoading={paymentLoading}
        blikCode={blikCode}
        handleBlikCodeChange={handleBlikCodeChange}
        onClose={() => toggleBlikCodeModal(false)}
        onSubmit={handleCreateOrder}
      />
    </>
  )
})

SubmitEditSaleOrderModal.displayName = 'SubmitEditSaleOrderModal'

export default SubmitEditSaleOrderModal
